import "../CampusTableComponent/CampusTableComponent.scss"

const CampusTableComponent = ({tableData}) => {
  return (
    <>
     <div className='campus-table-container' style={
        {paddingBottom:((tableData[0].title === "Sports Committee Members"|| 
            tableData[0].title === "Student Council Members" || 
            tableData[0].title === "Mentor Mentee Members" ||
            tableData[0].title === "Women cell Members" ||
            tableData[0].title === "Internal Compliance Committee Member" ||
            tableData[0].title === "Cyber Crime Awareness Member" ||
            tableData[0].title === "Anti Drug Awareness"||
            tableData[0].title === "Anti Ragging - Eve teasing Member")? "12.5px" :"25px"),
        paddingTop:(tableData[3] ? "0" : "12.5px")
        }
        }>
            {
             tableData[0].title !== "The Students Election for the year 2024-25 was conducted on 08.01.2025. The following students have been elected to the Students’ Association." &&   
             <h2 className='campus-table-title'>{tableData[0].title}</h2>
            }
                
                {
                    tableData[0].title === "The Students Election for the year 2024-25 was conducted on 08.01.2025. The following students have been elected to the Students’ Association." &&
                    <p className='campus-table-para-title'>{tableData[0].title}</p>
                }
                <div className='campus-table-subcontainer'>
                    <table className="campus-table" style={{paddingBottom:((tableData[0].title === "Sports Committee Members"|| tableData[0].title === "Student Council" ) ? "0%" :"12.5px")}}>
                        <thead>
                            {
                                tableData[1].headings.map((heading, index) => <>
                                    <tr key={index}>
                                        <th style={{width:"5%", textAlign:"center"}}>{heading.heading1}</th>
                                        <th style={{textAlign:"center"}} >{heading.heading2}</th>
                                        {heading.heading3 && <th style={{textAlign:"center"}}>{heading.heading3}</th>}
                                        <th style={{textAlign:"center"}}>{heading.heading4}</th>
                                        {heading.heading5 && <th>{heading.heading5}</th>}
                                    </tr>
                                </>)
                            }

                        </thead>
                        <tbody>
                            {tableData[2].data.map((row,index) => (
                                <tr key={index}>
                                    <td style={{textAlign:"center"}}>{row.id}</td>
                                    <td>{row.name}</td>
                                    {row.designDept && <td>{row.designDept}</td>}
                                    <td>{row.pos}</td>
                                    {row.emailId && <td>{row.emailId.toLowerCase()}</td>}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
    </>
  )
}

export default CampusTableComponent